import * as z from 'zod';

import { userRoleQuerySchema } from '@/_pages/settings/user-roles/shared';
import { countryQuerySchema } from '@/_schemas/countries/country-query-schema';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { teamMemberQueryLinkerSchema } from '@/_schemas/team-members/team-members-query-linker-schema';

import { systemUserQueryLinkerSchema } from './system-user-query-linker-schema';

import { customSettingsQuerySchema } from '../custom-settings/schemas/custom-settings-query-schema';

export const systemUserQuerySchema = z.object({
  ...systemUserQueryLinkerSchema.shape,

  user_type: z.string().nullable(),
  microsoft_groups: z.string().nullable(),
  roles: userRoleQuerySchema.array().nullish(),
  country: countryQuerySchema.nullish(),
  custom_settings: z.array(customSettingsQuerySchema).nullish(),
  team_member_id: z.number().nullable(),
  team_member: teamMemberQueryLinkerSchema.nullable(),

  api_keys: z.object({
    google_maps: z.string(),
    tiny_mce: z.string(),
  }),
});

export type SystemUserQuerySchema = z.infer<typeof systemUserQuerySchema>;

export const systemUserAllQuerySchema = paginatedResponseSchema(systemUserQuerySchema);

export type SystemUserAllQuerySchema = z.infer<typeof systemUserAllQuerySchema>;
